import { Link } from '@mui/material';
import React, { FC } from 'react';

import { LegalDocument } from '../../../../domain/config';

const DocumentLink: FC<{ document: LegalDocument; index: number; length: number }> = ({ document, index, length }) => (
  <>
    {' '}
    <Link href={document.url} target="_blank">
      {document.name}
    </Link>
    {length > 2 && index < length - 1 ? ',' : ''}
    {length > 1 && index === length - 2 ? ' and' : ''}
  </>
);

const DocumentLinks: React.FC<{ documents: Array<LegalDocument | null> }> = ({ documents }) => {
  const docs = documents.filter((doc) => doc !== null);
  return docs.map((doc: LegalDocument, index: number) => (
    <DocumentLink document={doc} index={index} key={doc.key} length={documents.length} />
  ));
};

export { DocumentLinks };
